import React, { useEffect } from "react"
import { Appearance, Platform } from "react-native"
import * as Sentry from "@sentry/react-native"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { GestureHandlerRootView } from "react-native-gesture-handler"
import { SafeAreaProvider } from "react-native-safe-area-context"
import BootSplash from "react-native-bootsplash"
import { ThemeProvider } from "@emotion/react"
import { ErrorDialog } from "./src/ui-components/ErrorDialog/ErrorDialog"
import { Router } from "./src/router/Router"
import { functionalColors } from "./src/ui-components/colors"

if (Platform.OS !== "web") {
  Appearance.setColorScheme("light")
}

const queryClient = new QueryClient()

function App(): React.JSX.Element {
  useEffect(() => {
    BootSplash.hide({ fade: true })
  }, [])

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <ThemeProvider theme={functionalColors}>
        <QueryClientProvider client={queryClient}>
          <SafeAreaProvider>
            <Router />
            <ErrorDialog />
          </SafeAreaProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </GestureHandlerRootView>
  )
}

export default Sentry.wrap(App)
